(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  /* Cart drawer runtime. Relies on global.js: trapFocus, removeTrapFocus, fetchConfig, debounce,
     publish/subscribe, PUB_SUB_EVENTS, <quantity-input>. */
  (function () {
    var ON_CHANGE_DEBOUNCE_TIMER = 300;

    function parseSection(html, selector) {
      return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    }

    /* Copy live toggle state into a freshly parsed drawer render so it survives re-renders. */
    function fixParsedHtml(drawer, parsedNode) {
      if (!drawer || !parsedNode) return;
      var newTimer = parsedNode.querySelector('.cart-timer');
      if (newTimer) {
        var oldTimer = drawer.querySelector('.cart-timer');
        if (oldTimer) newTimer.innerHTML = oldTimer.innerHTML;
      }
      var oldUpsells = drawer.querySelectorAll('cart-drawer-upsell[data-toggle="true"], cart-drawer-gift');
      var newUpsells = parsedNode.querySelectorAll('cart-drawer-upsell[data-toggle="true"], cart-drawer-gift');
      oldUpsells.forEach(function (oldUpsell, index) {
        var newUpsell = newUpsells[index];
        if (!newUpsell) return;
        if (oldUpsell.nodeName.toLowerCase() === 'cart-drawer-upsell') newUpsell.dataset.selected = oldUpsell.dataset.selected;
        newUpsell.dataset.id = oldUpsell.dataset.id;
        var oldId = oldUpsell.querySelector('[name="id"]');
        var newId = newUpsell.querySelector('[name="id"]');
        if (oldId && newId) newId.value = oldId.value;
        var oldImg = oldUpsell.querySelector('.upsell__image__img');
        var newImg = newUpsell.querySelector('.upsell__image__img');
        if (oldImg && newImg) newImg.src = oldImg.src;
        var toggle = newUpsell.querySelector('.upsell-toggle-btn');
        if (toggle) toggle.setAttribute('aria-pressed', newUpsell.dataset.selected === 'true' ? 'true' : 'false');
      });
    }

    /* ------------------------------------------------ remove button */
    if (!customElements.get('cart-remove-button')) {
      customElements.define('cart-remove-button', class CartRemoveButton extends HTMLElement {
        constructor() {
          super();
          this.addEventListener('click', function (event) {
            event.preventDefault();
            var cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
            if (!cartItems) return;
            this.clearCart ? cartItems.clearCart() : cartItems.updateQuantity(this.dataset.index, 0);
          }.bind(this));
        }
      });
    }

    /* ------------------------------------------------ toggle upsell (shipping protection) */
    if (!customElements.get('cart-drawer-upsell')) {
      customElements.define('cart-drawer-upsell', class CartDrawerUpsell extends HTMLElement {
        constructor() {
          super();
          this.toggleBtn = this.querySelector('.upsell-toggle-btn');
          this.idInput = this.querySelector('[name="id"]');
          if (this.toggleBtn) this.toggleBtn.addEventListener('click', this.handleToggle.bind(this));
          var form = this.querySelector('form');
          if (form) form.addEventListener('submit', function (event) { event.preventDefault(); this.addToCart(); }.bind(this));
        }
        get cartDrawer() { return this.closest('cart-drawer') || document.querySelector('cart-drawer'); }
        get cartItems() { var drawer = this.cartDrawer; return drawer ? drawer.querySelector('cart-drawer-items') : null; }
        get variantId() { return parseInt(this.idInput && this.idInput.value ? this.idInput.value : this.dataset.id, 10); }
        lineInCart() { var drawer = this.cartDrawer; return drawer ? drawer.querySelector('.cart-item--product-' + this.dataset.handle) : null; }
        handleToggle(event) {
          var tag = event.target.nodeName.toLowerCase();
          if (tag === 'select' || tag === 'option') return;
          if (this.dataset.selected === 'true') {
            this.dataset.selected = 'false';
            if (this.toggleBtn) this.toggleBtn.setAttribute('aria-pressed', 'false');
            this.removeFromCart();
          } else {
            this.dataset.selected = 'true';
            if (this.toggleBtn) this.toggleBtn.setAttribute('aria-pressed', 'true');
            this.addToCart();
          }
        }
        /* Run on load and after every render: re-attach when selected, detach when deselected. */
        addRemoveFromCart() {
          var drawer = this.cartDrawer;
          if (!drawer) return;
          if (this.dataset.selected === 'true' && !drawer.classList.contains('is-empty')) this.addToCart();
          else this.removeFromCart();
        }
        getUpdateRequired() {
          var line = this.lineInCart();
          return (line && this.dataset.selected === 'false') || (!line && this.dataset.selected === 'true');
        }
        addToCart() {
          var drawer = this.cartDrawer;
          var handle = this.dataset.handle;
          if (!drawer || this.lineInCart() || !this.variantId) return;
          if (drawer.pendingUpsells.has(handle) || drawer.failedUpsells.has(handle)) return;
          drawer.pendingUpsells.add(handle);
          if (this.toggleBtn) this.toggleBtn.setAttribute('disabled', '');
          var variantId = this.variantId;
          var config = fetchConfig('javascript');
          config.body = JSON.stringify({
            items: [{ id: variantId, quantity: 1 }],
            sections: drawer.getSectionsToRender().map(function (s) { return s.id; }),
            sections_url: window.location.pathname
          });
          fetch(window.routes.cart_add_url, config)
            .then(function (response) { return response.json(); })
            .then(function (response) {
              if (response.status) {
                drawer.failedUpsells.add(handle);
                this.dataset.selected = 'false';
                if (this.toggleBtn) { this.toggleBtn.removeAttribute('disabled'); this.toggleBtn.setAttribute('aria-pressed', 'false'); }
                return;
              }
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-drawer-upsell', productVariantId: variantId, cartData: response });
              drawer.renderContents(response, true);
            }.bind(this))
            .catch(function (error) {
              console.error(error);
              if (this.toggleBtn) this.toggleBtn.removeAttribute('disabled');
            }.bind(this))
            .finally(function () { drawer.pendingUpsells.delete(handle); });
        }
        removeFromCart() {
          var line = this.lineInCart();
          var cartItems = this.cartItems;
          if (!line || !cartItems) return;
          if (this.toggleBtn) this.toggleBtn.setAttribute('disabled', '');
          cartItems.updateQuantity(line.dataset.index, 0);
        }
      });
    }

    /* ------------------------------------------------ line items */
    if (!customElements.get('cart-drawer-items')) {
      customElements.define('cart-drawer-items', class CartDrawerItems extends HTMLElement {
        constructor() {
          super();
          this.lineItemStatusElement = document.getElementById('CartDrawer-LineItemStatus');
          var debouncedOnChange = debounce(function (event) { this.onChange(event); }.bind(this), ON_CHANGE_DEBOUNCE_TIMER);
          this.addEventListener('change', debouncedOnChange);
        }
        get cartDrawer() { return this.closest('cart-drawer') || document.querySelector('cart-drawer'); }
        connectedCallback() {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
            if (event && event.source === 'cart-items') this.updateCart();
          }.bind(this));
        }
        disconnectedCallback() { if (this.cartUpdateUnsubscriber) this.cartUpdateUnsubscriber(); }
        onChange(event) {
          if (!event.target.classList.contains('quantity__input')) return;
          this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
        }
        getSectionsToRender() {
          return [
            { id: 'CartDrawer', section: 'cart-drawer', selector: '.drawer__inner' },
            { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' }
          ];
        }
        getSectionInnerHTML(html, selector) {
          var node = parseSection(html, selector);
          if (!node) return '';
          if (selector === '.drawer__inner') fixParsedHtml(this.cartDrawer, node);
          return node.innerHTML;
        }
        renderSections(parsedState) {
          this.getSectionsToRender().forEach(function (section) {
            var host = document.getElementById(section.id);
            var target = host ? (host.querySelector(section.selector) || host) : document.querySelector(section.selector);
            var html = parsedState.sections && parsedState.sections[section.section];
            if (target && html) target.innerHTML = this.getSectionInnerHTML(html, section.selector);
          }.bind(this));
        }
        async updateQuantity(line, quantity, name) {
          this.enableLoading(line);
          var drawer = this.cartDrawer;
          var body = JSON.stringify({
            line: line,
            quantity: quantity,
            sections: this.getSectionsToRender().map(function (s) { return s.section; }),
            sections_url: window.location.pathname
          });
          try {
            var response = await fetch(window.routes.cart_change_url, Object.assign({}, fetchConfig(), { body: body }));
            var parsedState = JSON.parse(await response.text());
            var quantityElement = document.getElementById('Drawer-quantity-' + line);
            var items = document.querySelectorAll('.cart-item');
            if (parsedState.errors) {
              if (quantityElement) quantityElement.value = quantityElement.getAttribute('value');
              this.updateLiveRegions(line, parsedState.errors);
              return;
            }
            if (!parsedState.sections) {
              var sectionsResponse = await fetch(window.routes.cart_url + '?sections=' + this.getSectionsToRender().map(function (s) { return s.section; }).join(','));
              parsedState.sections = await sectionsResponse.json();
            }
            this.classList.toggle('is-empty', parsedState.item_count === 0);
            if (drawer) drawer.classList.toggle('is-empty', parsedState.item_count === 0);
            this.renderSections(parsedState);

            var updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
            var message = '';
            if (items.length === parsedState.items.length && quantityElement && updatedValue !== parseInt(quantityElement.value)) {
              message = typeof updatedValue === 'undefined' ? window.cartStrings.error : window.cartStrings.quantityError.replace('[quantity]', updatedValue);
            }
            this.updateLiveRegions(line, message);

            var lineItem = document.getElementById('CartDrawer-Item-' + line);
            if (lineItem && lineItem.querySelector('[name="' + name + '"]')) {
              drawer ? trapFocus(drawer, lineItem.querySelector('[name="' + name + '"]')) : lineItem.querySelector('[name="' + name + '"]').focus();
            } else if (parsedState.item_count === 0 && drawer) {
              trapFocus(drawer.querySelector('.drawer__inner-empty'), drawer.querySelector('a'));
            } else if (document.querySelector('.cart-item') && drawer) {
              trapFocus(drawer, document.querySelector('.cart-item__name'));
            }
            if (drawer) {
              drawer.upsellHandles = drawer.getUpsellHandles();
              drawer.checkForClear();
            }
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-drawer', cartData: parsedState });
          } catch (error) {
            console.error(error);
            this.querySelectorAll('.loading-overlay').forEach(function (overlay) { overlay.classList.add('hidden'); });
            var errors = document.getElementById('CartDrawer-CartErrors');
            if (errors) errors.textContent = window.cartStrings.error;
          } finally {
            this.disableLoading(line);
            document.dispatchEvent(new CustomEvent('cartQuantityUpdated', { detail: { handle: 'handle' } }));
          }
        }
        updateLiveRegions(line, message) {
          var lineItemError = document.getElementById('CartDrawer-LineItemError-' + line);
          if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;
          var status = document.getElementById('CartDrawer-LineItemStatus');
          if (status) status.setAttribute('aria-hidden', true);
          var liveRegion = document.getElementById('CartDrawer-LiveRegionText');
          if (liveRegion) {
            liveRegion.setAttribute('aria-hidden', false);
            setTimeout(function () { liveRegion.setAttribute('aria-hidden', true); }, 1000);
          }
        }
        enableLoading(line) {
          var container = document.getElementById('CartDrawer-CartItems');
          if (container) container.classList.add('cart__items--disabled');
          document.querySelectorAll('#CartDrawer-Item-' + line + ' .loading-overlay').forEach(function (overlay) { overlay.classList.remove('hidden'); });
          if (document.activeElement && document.activeElement.blur) document.activeElement.blur();
          var status = document.getElementById('CartDrawer-LineItemStatus');
          if (status) status.setAttribute('aria-hidden', false);
        }
        disableLoading(line) {
          var container = document.getElementById('CartDrawer-CartItems');
          if (container) container.classList.remove('cart__items--disabled');
          document.querySelectorAll('#CartDrawer-Item-' + line + ' .loading-overlay').forEach(function (overlay) { overlay.classList.add('hidden'); });
        }
        clearCart() {
          var drawer = this.cartDrawer;
          var body = JSON.stringify({
            sections: this.getSectionsToRender().map(function (s) { return s.section; }),
            sections_url: window.location.pathname
          });
          fetch(window.routes.cart_clear_url, Object.assign({}, fetchConfig(), { body: body }))
            .then(function (response) { return response.text(); })
            .then(function (text) {
              var parsedState = JSON.parse(text);
              this.classList.add('is-empty');
              if (drawer) drawer.classList.add('is-empty');
              this.renderSections(parsedState);
              if (drawer) {
                trapFocus(drawer.querySelector('.drawer__inner-empty'), drawer.querySelector('a'));
                drawer.upsellHandles = drawer.getUpsellHandles();
                drawer.checkForClear();
              }
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-drawer', cartData: parsedState });
            }.bind(this))
            .catch(function () {
              this.querySelectorAll('.loading-overlay').forEach(function (overlay) { overlay.classList.add('hidden'); });
              var errors = document.getElementById('CartDrawer-CartErrors');
              if (errors) errors.textContent = window.cartStrings.error;
            }.bind(this));
        }
        /* Silent re-sync (used when the cart page changes the cart). */
        updateCart() {
          var drawer = this.cartDrawer;
          if (!drawer) return;
          fetch(window.routes.cart_update_url + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates: {}, sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname })
          })
            .then(function (response) { return response.json(); })
            .then(function (parsedState) { drawer.renderContents(parsedState, true); })
            .catch(function (error) { console.error(error); });
        }
      });
    }

    /* ------------------------------------------------ the drawer */
    if (!customElements.get('cart-drawer')) {
      customElements.define('cart-drawer', class CartDrawer extends HTMLElement {
        constructor() {
          super();
          this.pendingUpsells = new Set();
          this.failedUpsells = new Set();
          this.upsellHandles = this.getUpsellHandles();
          this.checkForClear();
          this.addEventListener('keyup', function (event) { if (event.code === 'Escape') this.close(); }.bind(this));
          this.bindOverlay();
          this.setHeaderCartIconAccessibility();
        }
        connectedCallback() {
          setTimeout(function () { this.syncToggleUpsells(); }.bind(this));
        }
        bindOverlay() {
          var overlay = this.querySelector('#CartDrawer-Overlay');
          if (overlay && !overlay.dataset.bound) {
            overlay.dataset.bound = 'true';
            overlay.addEventListener('click', this.close.bind(this));
          }
        }
        setHeaderCartIconAccessibility() {
          var cartLink = document.querySelector('#cart-icon-bubble');
          if (!cartLink) return;
          cartLink.setAttribute('role', 'button');
          cartLink.setAttribute('aria-haspopup', 'dialog');
          cartLink.addEventListener('click', function (event) { event.preventDefault(); this.open(cartLink); }.bind(this));
          cartLink.addEventListener('keydown', function (event) {
            if (event.code.toUpperCase() === 'SPACE') { event.preventDefault(); this.open(cartLink); }
          }.bind(this));
        }
        open(triggeredBy) {
          if (triggeredBy) this.setActiveElement(triggeredBy);
          setTimeout(function () { this.classList.add('animate', 'active'); }.bind(this));
          this.addEventListener('transitionend', function () {
            var containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
            var focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
            if (containerToTrapFocusOn) trapFocus(containerToTrapFocusOn, focusElement);
          }.bind(this), { once: true });
          document.body.classList.add('overflow-hidden');
        }
        close() {
          this.classList.remove('active');
          removeTrapFocus(this.activeElement);
          document.body.classList.remove('overflow-hidden');
        }
        setActiveElement(element) { this.activeElement = element; }
        getUpsellHandles() {
          var handles = [];
          this.querySelectorAll('cart-drawer-upsell[data-toggle="true"], cart-drawer-gift').forEach(function (upsell) {
            if (upsell.dataset.handle) handles.push(upsell.dataset.handle);
          });
          return handles;
        }
        /* Items the product form may add in the same request: selected toggle upsells not yet in the cart. */
        getUpsellItems() {
          var items = [];
          this.querySelectorAll('cart-drawer-upsell[data-toggle="true"]').forEach(function (upsell) {
            if (upsell.dataset.selected !== 'true' || !upsell.dataset.id) return;
            if (this.querySelector('.cart-item--product-' + upsell.dataset.handle)) return;
            items.push({ id: parseInt(upsell.dataset.id, 10), quantity: 1 });
          }.bind(this));
          return items;
        }
        oneNonUpsellRemaining() {
          var items = this.querySelectorAll('.cart-item');
          var upsellLines = 0;
          items.forEach(function (item) {
            this.upsellHandles.forEach(function (handle) {
              if (item.classList.contains('cart-item--product-' + handle)) upsellLines++;
            });
          }.bind(this));
          return items.length - upsellLines <= 1;
        }
        /* When only one real product is left, removing it clears the whole cart (drops hidden add-ons). */
        checkForClear() {
          var clear = this.oneNonUpsellRemaining();
          this.querySelectorAll('cart-remove-button').forEach(function (button) { button.clearCart = clear; });
        }
        syncToggleUpsells() {
          this.querySelectorAll('cart-drawer-upsell[data-toggle="true"]').forEach(function (upsell) {
            if (upsell.addRemoveFromCart) upsell.addRemoveFromCart();
          });
        }
        getSectionsToRender() {
          return [
            { id: 'cart-drawer', section: 'cart-drawer', selector: '#CartDrawer' },
            { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' }
          ];
        }
        getSectionInnerHTML(html, selector) {
          var node = parseSection(html, selector || '.shopify-section');
          if (!node) return '';
          if (selector === '#CartDrawer') fixParsedHtml(this, node);
          return node.innerHTML;
        }
        renderContents(parsedState, isCartUpsell) {
          if (!parsedState) return;
          if (typeof parsedState.item_count === 'number') this.classList.toggle('is-empty', parsedState.item_count === 0);
          else this.classList.remove('is-empty');
          var inner = this.querySelector('.drawer__inner');
          if (inner) inner.classList.remove('is-empty');
          this.productId = parsedState.id;
          if (parsedState.sections) {
            this.getSectionsToRender().forEach(function (section) {
              var host = document.getElementById(section.id);
              var target = host ? (host.querySelector(section.selector) || host) : document.querySelector(section.selector);
              var html = parsedState.sections[section.id] || parsedState.sections[section.section];
              if (target && html) target.innerHTML = this.getSectionInnerHTML(html, section.selector);
            }.bind(this));
          }
          this.upsellHandles = this.getUpsellHandles();
          this.checkForClear();
          setTimeout(function () {
            this.bindOverlay();
            if (!isCartUpsell) this.open();
          }.bind(this));
          this.syncToggleUpsells();
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["countdown-bar"]) return;
  try {
    
  (function () {
    var bars = document.querySelectorAll('[data-countdown-bar]');
    if (!bars.length) return;
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };

    bars.forEach(function (bar) {
      var key = bar.dataset.key || 'countdown';
      var cycle = parseInt(bar.dataset.cycleSeconds, 10) || 86400;
      var hash = bar.dataset.hash || '';
      var onEnd = bar.dataset.onEnd || 'restart';
      var storageKey = 'gsc-countdown-' + key;
      var values = {
        days: bar.querySelector('[data-unit="days"] [data-unit-value]'),
        hours: bar.querySelector('[data-unit="hours"] [data-unit-value]'),
        mins: bar.querySelector('[data-unit="mins"] [data-unit-value]'),
        secs: bar.querySelector('[data-unit="secs"] [data-unit-value]')
      };

      function loadData() {
        try { return JSON.parse(localStorage.getItem(storageKey) || '{}') || {}; } catch (e) { return {}; }
      }
      function saveData(endDate) {
        try { localStorage.setItem(storageKey, JSON.stringify({ endDate: endDate.toISOString(), hash: hash })); } catch (e) {}
      }
      function newEnd() {
        var end = new Date(Date.now() + cycle * 1000);
        saveData(end);
        return end;
      }
      function getEnd() {
        var data = loadData();
        var end = data.endDate && data.hash === hash ? new Date(data.endDate) : null;
        if (!end || isNaN(end.getTime()) || end.getTime() <= Date.now()) end = newEnd();
        return end;
      }

      var endDate = getEnd();
      var lastSecond = -1;

      function tick() {
        var diff = endDate.getTime() - Date.now();
        if (diff <= 0) {
          if (onEnd === 'restart') {
            endDate = newEnd();
            diff = endDate.getTime() - Date.now();
          } else {
            diff = 0;
          }
        }
        var total = Math.floor(diff / 1000);
        if (total === lastSecond) return;
        lastSecond = total;
        var days = Math.floor(total / 86400);
        var hours = Math.floor((total % 86400) / 3600);
        var mins = Math.floor((total % 3600) / 60);
        var secs = total % 60;
        if (values.days) values.days.textContent = pad(days);
        if (values.hours) values.hours.textContent = pad(hours);
        if (values.mins) values.mins.textContent = pad(mins);
        if (values.secs) values.secs.textContent = pad(secs);
      }

      tick();
      window.setInterval(tick, 500);
      document.addEventListener('visibilitychange', tick);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function bind(root) {
      var items = root.querySelectorAll('.faq__q');
      items.forEach(function(btn) {
        if (btn.dataset.faqBound) return;
        btn.dataset.faqBound = 'true';
        btn.addEventListener('click', function() {
          var open = btn.getAttribute('aria-expanded') === 'true';
          var panel = btn.nextElementSibling;
          if (open) {
            btn.setAttribute('aria-expanded', 'false');
            panel.style.maxHeight = '0';
            panel.style.opacity = '0';
          } else {
            btn.setAttribute('aria-expanded', 'true');
            panel.style.maxHeight = panel.scrollHeight + 'px';
            panel.style.opacity = '1';
          }
        });
      });
    }
    document.querySelectorAll('[data-faq]').forEach(bind);
    document.addEventListener('shopify:section:load', function(event) {
      event.target.querySelectorAll('[data-faq]').forEach(bind);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-popup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('promo-popup-native')) {
    class PromoPopupNative extends HTMLElement {
      constructor() {
        super();
        this.testMode = this.dataset.testMode === 'true';
        this.secondsDelay = Number(this.dataset.delaySeconds) || 0;
        this.daysFrequency = Number(this.dataset.delayDays) || 0;
        this.overlayDismiss = this.dataset.overlayDismiss === 'true';
        this.suppressAfterSuccess = this.dataset.suppressAfterSuccess === 'true';
        this.modal = this.querySelector('.sign-up-popup-modal');
        this.overlay = this.querySelector('.sign-up-popup-overlay');
        this.closeBtns = this.querySelectorAll('.promp-popup__close-btn');
        this.views = this.querySelectorAll('.promo-popup__view');
        this.form = this.querySelector('.promo-popup__form');
        this.storageKey = 'promo-popup-data-' + window.location.host;
        this.successKey = 'promo-popup-subscribed-' + window.location.host;
        this.cookieName = 'promo_popup_' + this.dataset.section.replace(/[^a-zA-Z0-9_]/g, '_');
        this.isOpen = false;
        this.timer = null;

        this.closeBtns.forEach((btn) => btn.addEventListener('click', () => this.closeModal()));
        this.querySelectorAll('[data-action]').forEach((btn) => {
          btn.addEventListener('click', (event) => this.handleAction(event));
        });
        if (this.overlay) {
          this.overlay.addEventListener('click', () => {
            if (this.overlayDismiss) this.closeModal();
          });
        }
        this.onKeyup = (event) => {
          if (event.code && event.code.toUpperCase() === 'ESCAPE' && this.isOpen) this.closeModal();
        };
        if (this.form) this.form.addEventListener('submit', (event) => this.handleSubmit(event));
      }

      connectedCallback() {
        if (this.testMode) {
          this.openPopupModal(0);
          return;
        }
        if (this.isSuppressed()) return;
        this.openPopupModal(this.secondsDelay * 1000);
      }

      disconnectedCallback() {
        if (this.timer) clearTimeout(this.timer);
        document.removeEventListener('keyup', this.onKeyup);
      }

      /* ---- suppression: 1-day cookie/localStorage after close, permanent after a successful submit ---- */
      isSuppressed() {
        try {
          if (this.suppressAfterSuccess && localStorage.getItem(this.successKey) === 'true') return true;
          if (this.readCookie(this.cookieName)) return true;
          const raw = localStorage.getItem(this.storageKey);
          if (raw) {
            const data = JSON.parse(raw);
            const next = new Date(data.next_display_date);
            if (!isNaN(next.getTime()) && Date.now() < next.getTime()) return true;
          }
        } catch (e) {
          /* storage unavailable: fall through and show */
        }
        return false;
      }

      rememberDismissal() {
        const days = this.daysFrequency;
        const next = new Date(Date.now() + days * 24 * 60 * 60 * 1000);
        try {
          localStorage.setItem(this.storageKey, JSON.stringify({ next_display_date: next.toISOString(), dismissed: true }));
        } catch (e) {}
        if (days > 0) {
          document.cookie = this.cookieName + '=1; max-age=' + Math.round(days * 86400) + '; path=/; SameSite=Lax';
        }
      }

      rememberSuccess() {
        try {
          localStorage.setItem(this.successKey, 'true');
        } catch (e) {}
        this.rememberDismissal();
      }

      readCookie(name) {
        return document.cookie.split('; ').some((part) => part.indexOf(name + '=') === 0);
      }

      /* ---- open / close ---- */
      openPopupModal(delay) {
        if (this.timer) clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          if (!this.modal) return;
          // Never open over an open cart drawer; wait until the shopper closes it.
          const drawer = document.querySelector('cart-drawer');
          if (drawer && drawer.classList.contains('active')) {
            this.openPopupModal(2000);
            return;
          }
          this.showView(Number(this.dataset.startView) || 1);
          this.modal.classList.add('popup-modal--active');
          if (this.overlay) this.overlay.classList.add('popup-overlay--active');
          this.isOpen = true;
          document.addEventListener('keyup', this.onKeyup);
          if (typeof trapFocus === 'function') {
            trapFocus(this.modal, this.modal.querySelector('.promo-popup__button') || this.modal);
          } else {
            this.modal.focus();
          }
        }, delay);
      }

      closeModal() {
        if (!this.modal) return;
        this.modal.classList.remove('popup-modal--active');
        if (this.overlay) this.overlay.classList.remove('popup-overlay--active');
        this.isOpen = false;
        document.removeEventListener('keyup', this.onKeyup);
        if (typeof removeTrapFocus === 'function') removeTrapFocus();
        if (!this.testMode) this.rememberDismissal();
      }

      showView(index) {
        this.views.forEach((view) => {
          const match = Number(view.dataset.view) === index;
          view.hidden = !match;
        });
        if (index === 2) {
          const input = this.querySelector('.promo-popup__input');
          if (input) setTimeout(() => input.focus(), 50);
        }
      }

      /* ---- the two quiz buttons: 'email' (view 2), 'close', or 'link' ---- */
      handleAction(event) {
        const btn = event.currentTarget;
        const action = btn.dataset.action;
        if (action === 'email') {
          this.applySource(btn.dataset.source);
          this.showView(2);
        } else if (action === 'link' && btn.dataset.href) {
          this.rememberDismissal();
          window.location.href = btn.dataset.href;
        } else {
          this.closeModal();
        }
      }

      applySource(source) {
        if (!this.form || !source) return;
        const tags = this.form.querySelector('input[name="contact[tags]"]');
        if (!tags) return;
        const base = tags.dataset.baseTags || '';
        tags.value = base ? base + ', ' + source : source;
      }

      /* ---- email submit: POST the customer form in the background, then show the success view ---- */
      handleSubmit(event) {
        event.preventDefault();
        const form = event.currentTarget;
        const input = form.querySelector('.promo-popup__input');
        if (input && !input.checkValidity()) {
          input.setAttribute('aria-invalid', 'true');
          input.reportValidity();
          return;
        }
        if (input) input.removeAttribute('aria-invalid');
        const submitBtn = form.querySelector('button[type="submit"]');
        if (submitBtn) submitBtn.setAttribute('disabled', 'disabled');

        const body = new FormData(form);
        fetch(form.getAttribute('action') || '/contact', {
          method: 'POST',
          body: body,
          headers: { Accept: 'text/html' },
          credentials: 'same-origin'
        })
          .catch(() => {})
          .finally(() => {
            if (submitBtn) submitBtn.removeAttribute('disabled');
            if (this.suppressAfterSuccess) this.rememberSuccess();
            this.showView(3);
          });
      }
    }
    customElements.define('promo-popup-native', PromoPopupNative);
  }

  } catch(e) { console.error(e); }
})();
})();
